import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";

import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ScoreIcon from "@mui/icons-material/Score";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import KeyIcon from "@mui/icons-material/Key";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import InventoryIcon from "@mui/icons-material/Inventory";

import { Link } from "react-router-dom";

import Usuario from "../classes/Usuario";
import UsuarioDataSet from "../data/UsuarioDataSet";
import { hasInCache } from "../../helper/cacheHelper";
import UnidadeArmazenamento from "../classes/UnidadeArmazenamento";
import SKUDataSet from "../data/UnidadeArmazenamentoDataSet";
import Logout from "../../pages/singin/Logout";
import ParceiroHeader from "../../components/common/ParceiroHeader";
import ParceiroDataset from "../data/parceiroDataset";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "./LanguageSwitch/LanguageSwitch";

interface ItemMenu {
  label: string;
  path: string;
}

const Header = () => {
  const { t } = useTranslation();

  const settings: ItemMenu[] = [
    { label: t("header.account.myAccount"), path: "/portal/usuario" },
    { label: t("header.account.changePass"), path: "/portal/password" },
  ];
  const [anchorElNavMain, setAnchorElNavMain] =
    React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElNavSubPortal, setAnchorElNavSubPortal] =
    React.useState<null | HTMLElement>(null);
  const [anchorElNavSubPlanejamento, setAnchorElNavSubPlanejamento] =
    React.useState<null | HTMLElement>(null);
  const [anchorElNavSubProducao, setAnchorElNavSubProducao] =
    React.useState<null | HTMLElement>(null);
  const [anchorElNavSubPedidos, setAnchorElNavSubPedidos] =
    React.useState<null | HTMLElement>(null);
  const [anchorElNavSubEntregas, setAnchorElNavSubEntregas] =
    React.useState<null | HTMLElement>(null);
  const [anchorElNavSubEstoque, setAnchorElNavSubEstoque] =
    React.useState<null | HTMLElement>(null);
  const [anchorElNavSubDashboard, setAnchorElNavSubDashboard] =
    React.useState<null | HTMLElement>(null);

  const parceiroDataSet = new ParceiroDataset();

  const [pages, setPages] = React.useState<String[]>([]);
  const [portal, setPortal] = React.useState<ItemMenu[]>([]);
  const [planejamento, setPlanejamento] = React.useState<ItemMenu[]>([]);
  const [producao, setProducao] = React.useState<ItemMenu[]>([]);
  const [pedidos, setPedidos] = React.useState<ItemMenu[]>([]);
  const [entregas, setEntregas] = React.useState<ItemMenu[]>([]);
  const [estoque, setEstoque] = React.useState<ItemMenu[]>([]);
  const [dashboard, setDashboard] = React.useState<ItemMenu[]>([]);
  const userDataSet = new UsuarioDataSet();
  const [usuario, SetUsuario] = React.useState(new Usuario());

  const _pagesIcons: any[] = [
    DesktopWindowsIcon,
    ScoreIcon,
    PrecisionManufacturingIcon,
    ReceiptIcon,
    LocalShippingIcon,
    InventoryIcon,
    DashboardIcon,
  ];

  React.useEffect(() => {
    let user: Usuario = JSON.parse(
      String(localStorage.getItem(userDataSet.getKeyCach()))
    );
    SetUsuario(user);
    MontaMenus(user);
    let skudata: SKUDataSet = new SKUDataSet();
    if (!hasInCache(skudata.getKeyCach())) {
      let UnidadeArmazenamentos: UnidadeArmazenamento[] = [];
      skudata.ListarAtivos().then((result) => {
        UnidadeArmazenamentos = result;
        skudata.AdicionarListaAoCache(result);
      });
    }
  }, [t]);

  // function verifyIfExistsContractInStorage() {
  //   let contract: boolean = !!localStorage.getItem("ContratoSelecionado");
  //   return contract;
  // }

  function MontaMenus(_usuario: Usuario) {
    let root: boolean = _usuario?.regras?.some(
      (r) => r.descricao.toUpperCase() === "ROOT"
    );
    let planejamentoBRF: boolean = _usuario?.regras?.some(
      (r) => r.descricao.toUpperCase() === "PLANEJAMENTOBRF"
    );
    let materiaprimaBRF: boolean = _usuario?.regras?.some(
      (r) => r.descricao.toUpperCase() === "MATERIAPRIMABRF"
    );
    let planejamentoCOP: boolean = _usuario?.regras?.some(
      (r) => r.descricao.toUpperCase() === "PLANEJAMENTOCOPAKER"
    );
    let materiaprimaCOP: boolean = _usuario?.regras?.some(
      (r) => r.descricao.toUpperCase() === "MATERIAPRIMACOPAKER"
    );
    let suporteBRF: boolean = _usuario?.regras?.some(
      (r) => r.descricao.toUpperCase() === "SUPORTEBRF"
    );
    let suporteCOP: boolean = _usuario?.regras?.some(
      (r) => r.descricao.toUpperCase() === "SUPORTECOPACKER"
    );

    let _pages: any[] = [];
    let _portal: ItemMenu[] = [];
    let _planejamento: ItemMenu[] = [];
    let _producao: ItemMenu[] = [];
    let _pedidos: ItemMenu[] = [];
    let _entregas: ItemMenu[] = [];
    let _estoque: ItemMenu[] = [];
    let _dashboard: ItemMenu[] = [];

    if (root || suporteBRF) {
      _pages = [
        t("header.menu.portal"),
        t("header.menu.planning"),
        t("header.menu.production"),
        t("header.menu.requests"),
        t("header.menu.deliveries"),
        t("header.menu.stock"),
        t("header.menu.dashboard"),
      ];
      _portal = [
        {
          label: t("header.submenu.portal.portalParameters"),
          path: "/portal/parametroPortal",
        },
        {
          label: t("header.submenu.portal.parameters"),
          path: "/portal/parametros",
        },
        { label: t("header.submenu.portal.partner"), path: "/portal/parceiro" },
        {
          label: t("header.submenu.portal.agregatedPartner"),
          path: "/portal/parceiroAgregado",
        },
        {
          label: t("header.submenu.portal.parameterPartner"),
          path: "/portal/parceiro/parametros",
        },
        { label: t("header.submenu.portal.profile"), path: "/portal/perfil" },
        { label: t("header.submenu.portal.user"), path: "/portal/usuario" },
        {
          label: t("header.submenu.portal.passwordChange"),
          path: "/portal/password",
        },
        { label: t("header.submenu.portal.ssoConfig"), path: "/portal/sso" },
        {
          label: t("header.submenu.portal.basicData"),
          path: "/portal/dadosBasicos",
        },
        {
          label: t("header.submenu.portal.emailGroups"),
          path: "/portal/grupoemail",
        },
      ];

      _planejamento = [
        {
          label: t("header.submenu.planning.justification"),
          path: "/planejamento/justificativas",
        },
        {
          label: t("header.submenu.planning.projects"),
          path: "/planejamento/projetos",
        },
        {
          label: t("header.submenu.planning.contract"),
          path: "/planejamento/contratos",
        },
        {
          label: t("header.submenu.planning.monthlyForecats"),
          path: "/planejamento/forecast",
        },
        {
          label: t("header.submenu.planning.dailyForecats"),
          path: "/planejamento/forecastDia",
        },
        {
          label: t("header.submenu.planning.stuffRequest"),
          path: "/planejamento/materiaprima",
        },
      ];

      _producao = [
        {
          label: t("header.submenu.production.dailyProductionRelease"),
          path: "/producao/lancamentoProducao?step=1",
        },
        {
          label: t("header.submenu.production.deviationsApproval"),
          path: "/producao/lancamentoProducao?step=2",
        },
      ];
      _pedidos = [
        {
          label: t("header.submenu.requests.finishedProduct"),
          path: "/entrega/produtoAcabado",
        },
        {
          label: t("header.submenu.requests.importRequest"),
          path: "/pedidos/pedidoImportacao",
        },
      ];
      _entregas = [
        {
          label: t("header.submenu.deliveries.fob"),
          path: "/entrega/acompanhamentoFOB",
        },
        {
          label: t("header.submenu.deliveries.cif"),
          path: "/entrega/acompanhamentoCIF",
        },
        {
          label: t("header.submenu.deliveries.stuff"),
          path: "/entrega/acompanhamentoMateriaPrima",
        },
      ];
      _estoque = [
        {
          label: t("header.submenu.stock.brfPartner"),
          path: "/estoque/parceirobrf",
        },
        { label: t("header.submenu.stock.partner"), path: "/estoque/parceiro" },
      ];
      _dashboard = [
        {
          label: t("header.submenu.dashboad.productionMonitoring"),
          path: "/dashboard/otifDashboard",
        },
        {
          label: t("header.submenu.dashboad.contractualConsumption"),
          path: "/dashboard/consumoContratual",
        },
        {
          label: t("header.submenu.dashboad.import"),
          path: "/dashboard/importacao",
        },
        {
          label: t("header.submenu.dashboad.partnerMonitoring"),
          path: "/dashboard/acompanhamentoParceiros",
        },
      ];
    } else {
      if (suporteBRF) {
        // _pages = [t("header.menu.portal")];
        // _portal = [{ label: "Dados Básicos", path: "/portal/dadosbasicos" }];
        // _planejamento = [];
        // _producao = [];
        // _pedidos = [];
        // _entregas = [];
        // _dashboard = [];
      } else {
        if (suporteCOP) {
          _pages = [t("header.menu.portal")];
          _portal = [{ label: "Usuário", path: "/portal/usuario" }];
          _planejamento = [];
          _producao = [];
          _pedidos = [];
          _entregas = [];
        } else {
          if (planejamentoBRF) {
            _pages = [
              t("header.menu.planning"),
              t("header.menu.production"),
              t("header.menu.requests"),
              t("header.menu.deliveries"),
              t("header.menu.stock"),
              t("header.menu.dashboard"),
            ];
            _portal = [];

            _planejamento = [
              { label: "Contrato", path: "/planejamento/contratos" },
              {
                label: "Forecast Mensal - Plano Base",
                path: "/planejamento/forecast?step=1",
              },
              {
                label: "Forecast Mensal - Aprovar/Reprovar",
                path: "/planejamento/forecast?step=3",
              },
              {
                label: "Forecast Mensal - Consulta",
                path: "/planejamento/forecast?step=4",
              },
              {
                label: "Forecast Diario - Aprovar/Reprovar",
                path: "/planejamento/forecastDia?step=2",
              },
              {
                label: "Forecast Diario - Itens liberados",
                path: "/planejamento/forecastDia?step=3",
              },
            ];

            _producao = [
              {
                label: "Lançamento Diario de Produção",
                path: "/producao/lancamentoProducao?step=1",
              },
              {
                label: "Aprovação de Desvios",
                path: "/producao/lancamentoProducao?step=2",
              },
            ];
            _pedidos = [
              {
                label: "Produto Acabado - Priorizar Entregas",
                path: "/entrega/produtoAcabado?step=2",
              },
              {
                label: "Produto Acabado - Gerar Pré-Ordem",
                path: "/entrega/produtoAcabado?step=3",
              },
              {
                label: "Produto Acabado - Produtos Já Solicitados",
                path: "/entrega/produtoAcabado?step=4",
              },
              { label: "Pedido Importação", path: "/pedidos/pedidoImportacao" },
            ];

            _entregas = [
              { label: "FOB", path: "/entrega/acompanhamentoFOB" },
              { label: "CIF", path: "/entrega/acompanhamentoCIF" },
              {
                label: "Matéria Prima",
                path: "/entrega/acompanhamentoMateriaPrima",
              },
            ];

            _estoque = [
              { label: "Parceiro BRF", path: "/estoque/parceirobrf" },
              { label: "Parceiro", path: "/estoque/parceiro" },
            ];
            _dashboard = [
              {
                label: "Acompanhamento de Produção",
                path: "/dashboard/otifDashboard",
              },
              {
                label: "Consumo Contratual",
                path: "/dashboard/consumoContratual",
              },
              { label: "Importação", path: "/dashboard/importacao" },
              {
                label: "Acompanhamento Parceiros",
                path: "/dashboard/acompanhamentoParceiros",
              },
            ];
          } else {
            if (planejamentoCOP) {
              _pages = [
                t("header.menu.planning"),
                t("header.menu.production"),
                t("header.menu.requests"),
                t("header.menu.deliveries"),
              ];
              _portal = [];

              _planejamento = [
                { label: "Contrato", path: "/planejamento/contratos" },
                {
                  label: "Forecast Mensal - Sugerir Alterações",
                  path: "/planejamento/forecast?step=2",
                },
                {
                  label: "Forecast Mensal - Consulta",
                  path: "/planejamento/forecast?step=4",
                },
                {
                  label: "Forecast Diario - Plano Base",
                  path: "/planejamento/forecastDia?step=1",
                },
                {
                  label: "Forecast Diario - Itens liberados",
                  path: "/planejamento/forecastDia?step=3",
                },
              ];

              _producao = [
                {
                  label: "Lançamento Diario de Produção",
                  path: "/producao/lancamentoProducao?step=1",
                },
                {
                  label: "Consulta de Lançamentos",
                  path: "/producao/lancamentoProducao?step=2",
                },
              ];
              _pedidos = [
                {
                  label: "Produto Acabado - Produtos Disponíveis",
                  path: "/entrega/produtoAcabado?step=1",
                },
                {
                  label: "Produto Acabado - Produtos Já Solicitados",
                  path: "/entrega/produtoAcabado?step=4",
                },
              ];
              _entregas = [
                { label: "FOB", path: "/entrega/acompanhamentoFOB" },
                { label: "CIF", path: "/entrega/acompanhamentoCIF" },
              ];
              _dashboard = [{ label: "Acompanhamento Parceiros", path: "/" }];
            } else {
              if (materiaprimaBRF || materiaprimaCOP) {
                _pages = [t("header.menu.planning")];
                _portal = [];
                _planejamento = [
                  {
                    label: "Solicitação de Matéria Prima",
                    path: "/planejamento/materiaprima",
                  },
                ];
                _producao = [];
                _pedidos = [
                  { label: "Produto Acabado", path: "/entrega/produtoAcabado" },
                ];
                _entregas = [];
              }
            }
          }
        }
      }
    }

    setPages(_pages);
    setPortal(_portal);
    setPlanejamento(_planejamento);
    setProducao(_producao);
    setPedidos(_pedidos);
    setEntregas(_entregas);
    setEstoque(_estoque);
    setDashboard(_dashboard);
  }

  const openPortal = Boolean(anchorElNavSubPortal);
  const openPlanejamento = Boolean(anchorElNavSubPlanejamento);
  const openProducao = Boolean(anchorElNavSubProducao);
  const openPedidos = Boolean(anchorElNavSubPedidos);
  const openEntregas = Boolean(anchorElNavSubEntregas);
  const openDashboard = Boolean(anchorElNavSubDashboard);
  const openEstoque = Boolean(anchorElNavSubEstoque);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNavMain(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenNavMenuSubPortal = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNavSubPortal(event.currentTarget);
  };

  const handleOpenNavMenuSubPlanejamento = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorElNavSubPlanejamento(event.currentTarget);
  };

  const handleOpenNavMenuSubProducao = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorElNavSubProducao(event.currentTarget);
  };

  const handleOpenNavMenuSubPedidos = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorElNavSubPedidos(event.currentTarget);
  };

  const handleOpenNavMenuSubEntregas = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorElNavSubEntregas(event.currentTarget);
  };

  const handleOpenNavMenuSubDashboard = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorElNavSubDashboard(event.currentTarget);
  };

  const handleOpenNavMenuSubEstoque = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorElNavSubEstoque(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNavMain(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleCloseNavMenuSubPortal = () => {
    setAnchorElNavSubPortal(null);
  };

  const handleCloseNavMenuSubPlanejamento = () => {
    setAnchorElNavSubPlanejamento(null);
  };

  const handleCloseNavMenuSubProducao = () => {
    setAnchorElNavSubProducao(null);
  };

  const handleCloseNavMenuSubPedidos = () => {
    setAnchorElNavSubPedidos(null);
  };

  const handleCloseNavMenuSubEntregas = () => {
    setAnchorElNavSubEntregas(null);
  };

  const handleCloseNavMenuSubEstoque = () => {
    setAnchorElNavSubEstoque(null);
  };

  const handleCloseNavMenuSubDashboard = () => {
    setAnchorElNavSubDashboard(null);
  };

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "white", color: "#666", height: "5rem" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
          ></Typography>
          <Box
            id="boxMenu"
            key="bxM"
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
          >
            <Link key={"home"} to="/">
              <div className="logo" />
            </Link>
            {"   "}
          </Box>
          <Box
            id="boxSandwich"
            key="bxSHeaderKey"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              key={"ibsand"}
            >
              <MenuIcon key={"misand"} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNavMain}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNavMain)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
              key={"mnsand"}
            >
              {pages.map((page) => (
                <MenuItem
                  key={"mi" + page}
                  onClick={handleCloseNavMenu}
                  className="MenuSuperior"
                >
                  <Typography textAlign="center" key={"miTypo" + page}>
                    {page}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            id="boxMenu"
            key="bxMnu"
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
          >
            {pages.map((page, index) => (
              <Box key={"boxMenu" + page + "i" + index}>
                <Button
                  className="buttonMenu"
                  key={"btMenu" + page + "i" + index}
                  onClick={
                    page === t("header.menu.portal")
                      ? handleOpenNavMenuSubPortal
                      : page === t("header.menu.planning")
                      ? handleOpenNavMenuSubPlanejamento
                      : page === t("header.menu.production")
                      ? handleOpenNavMenuSubProducao
                      : page === t("header.menu.dashboard")
                      ? handleOpenNavMenuSubDashboard
                      : page === t("header.menu.stock")
                      ? handleOpenNavMenuSubEstoque
                      : page === t("header.menu.requests")
                      ? handleOpenNavMenuSubPedidos
                      : handleOpenNavMenuSubEntregas
                  }
                  sx={{ my: 2, color: "#666", display: "block" }}
                  startIcon={
                    index === 0 ? (
                      <DesktopWindowsIcon />
                    ) : index === 1 ? (
                      <ScoreIcon />
                    ) : index === 2 ? (
                      <PrecisionManufacturingIcon />
                    ) : index === 3 ? (
                      <ReceiptIcon />
                    ) : index === 4 ? (
                      <LocalShippingIcon />
                    ) : index === 5 ? (
                      <InventoryIcon />
                    ) : (
                      <DashboardIcon />
                    )
                  }
                >
                  {page}
                </Button>
                <Menu
                  id={"fade-menu-" + page}
                  key={"fadeMenu" + page}
                  MenuListProps={{
                    "aria-labelledby": "fade-button",
                  }}
                  anchorEl={
                    page === t("header.menu.portal")
                      ? anchorElNavSubPortal
                      : page === t("header.menu.planning")
                      ? anchorElNavSubPlanejamento
                      : page === t("header.menu.production")
                      ? anchorElNavSubProducao
                      : page === t("header.menu.dashboard")
                      ? anchorElNavSubDashboard
                      : page == t("header.menu.stock")
                      ? anchorElNavSubEstoque
                      : page === t("header.menu.requests")
                      ? anchorElNavSubPedidos
                      : anchorElNavSubEntregas
                  }
                  open={
                    page === t("header.menu.portal")
                      ? openPortal
                      : page === t("header.menu.planning")
                      ? openPlanejamento
                      : page === t("header.menu.production")
                      ? openProducao
                      : page === t("header.menu.dashboard")
                      ? openDashboard
                      : page == t("header.menu.stock")
                      ? openEstoque
                      : page === t("header.menu.requests")
                      ? openPedidos
                      : openEntregas
                  }
                  onClose={
                    page === t("header.menu.portal")
                      ? handleCloseNavMenuSubPortal
                      : page === t("header.menu.planning")
                      ? handleCloseNavMenuSubPlanejamento
                      : page === t("header.menu.production")
                      ? handleCloseNavMenuSubProducao
                      : page === t("header.menu.dashboard")
                      ? handleCloseNavMenuSubDashboard
                      : page == t("header.menu.stock")
                      ? handleCloseNavMenuSubEstoque
                      : page === t("header.menu.requests")
                      ? handleCloseNavMenuSubPedidos
                      : handleCloseNavMenuSubEntregas
                  }
                  TransitionComponent={Fade}
                >
                  {page === t("header.menu.portal")
                    ? portal.map((sub) => (
                        <Link key={"lk" + sub.label} to={sub.path}>
                          <MenuItem
                            key={"po" + sub.label}
                            onClick={handleCloseNavMenuSubPortal}
                          >
                            {sub.label}
                          </MenuItem>
                        </Link>
                      ))
                    : page === t("header.menu.planning")
                    ? planejamento.map((sub) => (
                        <Link key={"lk" + sub.label} to={sub.path}>
                          <MenuItem
                            key={"pl" + sub.label}
                            onClick={handleCloseNavMenuSubPlanejamento}
                          >
                            {sub.label}
                          </MenuItem>
                        </Link>
                      ))
                    : page === t("header.menu.production")
                    ? producao.map((sub) => (
                        <Link key={"lk" + sub.label} to={sub.path}>
                          <MenuItem
                            key={"pr" + sub.label}
                            onClick={handleCloseNavMenuSubProducao}
                          >
                            {sub.label}
                          </MenuItem>
                        </Link>
                      ))
                    : page === t("header.menu.dashboard")
                    ? dashboard.map((sub) => (
                        <Link key={"lk" + sub.label} to={sub.path}>
                          <MenuItem
                            key={"pe" + sub.label}
                            onClick={handleCloseNavMenuSubDashboard}
                          >
                            {sub.label}
                          </MenuItem>
                        </Link>
                      ))
                    : page === t("header.menu.stock")
                    ? estoque.map((sub) => (
                        <Link key={"lk" + sub.label} to={sub.path}>
                          <MenuItem
                            key={"pe" + sub.label}
                            onClick={handleCloseNavMenuSubEstoque}
                          >
                            {sub.label}
                          </MenuItem>
                        </Link>
                      ))
                    : page === t("header.menu.requests")
                    ? pedidos.map((sub) => (
                        <Link key={"lk" + sub.label} to={sub.path}>
                          <MenuItem
                            key={"pe" + sub.label}
                            onClick={handleCloseNavMenuSubPedidos}
                          >
                            {sub.label}
                          </MenuItem>
                        </Link>
                      ))
                    : entregas.map((sub) => (
                        <Link key={"lk" + sub.label} to={sub.path}>
                          <MenuItem
                            key={"en" + sub.label}
                            onClick={handleCloseNavMenuSubEntregas}
                          >
                            {sub.label}
                          </MenuItem>
                        </Link>
                      ))}
                </Menu>
              </Box>
            ))}
          </Box>
          <Box
            id="boxSelecao"
            key="boxSelecao"
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
          >
            <ParceiroHeader key={"parceiroHeader"} />
          </Box>
          <Box mr={2}>
            <LanguageSwitch />
          </Box>
          <Box id="boxAvatar" key="boxAvatar" sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings" key={"ops"}>
              <IconButton
                key={"ops1"}
                onClick={handleOpenUserMenu}
                sx={{ p: 0 }}
              >
                <Avatar
                  key={"ops2"}
                  alt={usuario?.nome}
                  src="/static/images/avatar/2.jpg"
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "35px" }}
              id="menu-appbar-avatar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              key={"outracoisa"}
            >
              {settings.map((setting, index) => (
                <Link key={"lks" + setting.label} to={setting.path}>
                  <MenuItem
                    key={"mii" + setting.label}
                    onClick={handleCloseUserMenu}
                  >
                    <Typography textAlign="center">
                      {index === 0 ? (
                        <PersonIcon fontSize="small" />
                      ) : index === 1 ? (
                        <KeyIcon fontSize="small" />
                      ) : index === 2 ? (
                        <DashboardIcon fontSize="small" />
                      ) : (
                        <LogoutIcon fontSize="small" />
                      )}
                      {"  "}
                      {setting.label}
                    </Typography>
                  </MenuItem>
                </Link>
              ))}
              <Logout />
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;
